import { autoinject } from 'aurelia-framework';
import { json } from 'aurelia-fetch-client';
import { ApiService } from '../../utils/api-service';
import { IText } from '../../utils/translator';

@autoinject
export class AccountTagService {
	constructor(private api: ApiService) {
	}

	async getAccountTags(): Promise<IAccountTagAM[]> {
		return await this.api.fetchJson('account-tags');
	}

	addTagForAccount(accountId: string, accountTagId: string): Promise<any> {
		return this.api.fetch(
			`accounts/${accountId}/add-tag/${accountTagId}`,
			{ method: 'post' }
		);
	}

	removeTagFromAccount(accountId: string, accountTagId: string): Promise<any> {
		return this.api.fetch(
			`accounts/${accountId}/remove-tag/${accountTagId}`,
			{ method: 'post' }
		);
	}
}

export interface IAccountTagAM {
	id: string;
	nameText: string;
	code: string;
}
